var _mask, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTrofeu(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "tromask",
    "mask-type": "alpha",
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 24,
    height: 25
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.84 0.686035H21H19.2C18.12 0.686035 16.8 1.88108 16.8 3.07612H7.2C7.2 1.88108 5.88 0.686035 4.8 0.686035H3H2.16H0V11.4414C0 12.6365 1.2 13.8315 2.4 13.8315H5.04C5.52 16.2216 7.08 18.2532 10.8 18.6117V21.1213C8.16 21.3603 7.2 22.6748 7.2 24.2284V24.5869H16.8V24.2284C16.8 22.6748 15.84 21.3603 13.2 21.1213V18.6117C16.92 18.2532 18.48 16.2216 18.96 13.8315H21.6C22.8 13.8315 24 12.6365 24 11.4414V0.686035H21.84ZM2.4 11.4414V3.07612H4.8V5.4662V11.4414C3.72 11.4414 2.76 11.4414 2.4 11.4414ZM21.6 11.4414C21.24 11.4414 20.28 11.4414 19.2 11.4414V5.4662V3.07612H21.6V11.4414Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#tromask)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -47.5,
    y: -33.4702,
    width: 108.2,
    height: 117.309,
    fill: "#008AAC",
    stroke: "#009FD2"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrofeu);
export default __webpack_public_path__ + "static/media/trofeu.54f87a8dd6ee9faab87ecf50abeda29d.svg";
export { ForwardRef as ReactComponent };